import type { Organization } from "@App/types";
import { gql } from "@apollo/client";

export interface GetGaragesResponse {
  organization: Organization;
}

export const GET_GARAGES = gql`
    query getGarageList(
        $id: ID,
        $ids: [ID!],
        $organization:ID!,
        $lat:Float,
        $lon:Float,
        $distance:Int,
        $appointmentsFrom: DateTimeTz,
        $appointmentsTo: DateTimeTz,
        $services: [ID],
        $search: String,
        $sortBy: String,
        $premiumServices: [ID],
        $slug: String,
        $offset: Int,
        $limit: Int,
        $brand: ID,
        $generation: ID,
        $motorization: ID,
        $gearbox: ID,
        $body: ID,
        $mileage: Int,
        $registrationDate: Date,
        $subRepairs: [String],
        $equipments: [String],
        $supportsBev: Boolean,
        $supportsCommercialVehicles: Boolean,
        $onlyBookable: Boolean,
        $driverId: UUID,
        $garageTypes: [ID]
        $garageChains: [ID],
        $presetFilters: [PresetFilter],
        $garageProperties: [UUID!],
        $onlyPreferredPartners: Boolean,
        $networkId: ID) {
        organization(id: $organization) {
            id
            uuid
            garages(
                id: $id,
                ids: $ids,
                lat: $lat,
                lon: $lon,
                distance: $distance,
                appointmentsFrom: $appointmentsFrom,
                appointmentsTo: $appointmentsTo,
                search: $search,
                sortBy: $sortBy,
                services: $services,
                premiumServices: $premiumServices,
                slug: $slug,
                offset: $offset,
                limit: $limit,
                brand: $brand,
                garageTypes: $garageTypes,
                calculation: {
                    services: $services,
                    brand: $brand,
                    generation: $generation,
                    motorization: $motorization,
                    mileage: $mileage,
                    gearbox: $gearbox,
                    body: $body,
                    registration_date: $registrationDate,
                    sub_repairs: $subRepairs,
                    equipments: $equipments,
                },
                supportsBev: $supportsBev,
                supportsCommercialVehicles: $supportsCommercialVehicles,
                onlyBookable: $onlyBookable,
                garageChains: $garageChains,
                driver: $driverId,
                presetFilters: $presetFilters,
                garageProperties: $garageProperties,
                onlyPreferredPartners: $onlyPreferredPartners,
                networkId: $networkId,
            ){
                data {
                    id
                    uuid
                    name
                    slug
                    distance
                    travel_time
                    lat
                    lon
                    rating
                    review_count
                    street
                    cover_image
                    city
                    postcode
                    phone
                    garageChain {
                        id
                    }
                    garageType {
                        id
                        name
                        display_name_singular
                    }
                    nationwide_service
                    authorizedBrands {
                        id
                        name
                    }
                    available_days(services: $services) {
                        id
                        available_at
                    }
                    premium_services(services: $services) {
                        id
                        name
                        paid
                        filterable
                        show_in_list
                        type
                    }
                    checkpoint {
                        id
                        name
                        logo
                    }
                    pivot {
                        bookable
                        preferred_partner
                    }
                    liveBookable(services: $services)
                    drivingLicenseCheckpoint {
                        name
                    }
                    billingGroups {
                        display_name
                    }
                    garageProperties {
                        id
                        detail_view_text
                        show_in_detail_view
                        filter_text
                        show_in_filter
                        list_text
                        show_in_list
                    }
                }
                network {
                    id
                    name
                }
                paginatorInfo {
                    hasMorePages
                }
            }
        }
    }
`;
